import { RATE_CARD_TYPE_PRICING, TMultiRatePrice, TRateCard } from '@types';

type TAnyPrice = TRateCard | TMultiRatePrice | null | undefined;

/** Whether the payload asks for PER_ITEM, the multi-rate pricing method. */
export const isMultiRatePayload = (payload?: { pricing_method?: string | null } | null): boolean =>
	payload?.pricing_method === RATE_CARD_TYPE_PRICING.PER_ITEM;

/** The form's PER_ITEM payload as the v1 store takes it: switched on by `is_multi_rate`. */
export const toMultiRateStorePayload = <T extends { pricing_method?: string | null }>(payload: T): T & { is_multi_rate: true } =>
	({ ...payload, is_multi_rate: true });

/** A multi-rate price carries the shape flag and one item per cargo row, whatever its method. */
export const isMultiRatePrice = (price: TAnyPrice): price is TMultiRatePrice =>
	price?.isMultiRate === true && Array.isArray(price.items);

/** Tells one listed price from another: rate card or lane, per freight mode (a lane prices every mode). */
export const priceKeyOf = (price: TAnyPrice): string | undefined =>
	price ? `${price.rateCardExternalId ?? price.laneId}:${price.freightMode}` : undefined;
